import * as z from "zod/v4";

import { pricingInclusionMode } from "./pricing-inclusion-mode";

const redoMarketOutput = z.object({
  id: z.string(),
  source: z.string(),
  sourceMarketId: z.string(),
  sourceCatalogId: z.string().nullable(),
  sourcePriceListId: z.string().nullable(),
  shopCurrency: z.string(),
  currency: z.string(),
  enabled: z.boolean(),
  inclusionMode: pricingInclusionMode,
  markupRate: z.string(),
  lastSyncedAt: z.date().nullable(),
});

export const getRedoMarkets = {
  name: "getRedoMarkets" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ markets: z.array(redoMarketOutput) }),
};
